export default "__VITE_ASSET__f6893bce__"